import {IInboxMessagePreview} from '@trycourier/react-provider';

export interface IInboxMessagePreviewWithTags extends IInboxMessagePreview {
  tags?: string[];
}

export const DIRECT_MESSAGE = 'DIRECT_MESSAGE';
export const orgPrefix = 'orgId:';
export const nanoPrefix = 'nanoId:';

/**
 * While arrays in JSON guarantee array ordering, it makes sense to "name" somehow the values transported within Courier
 * in case another value is added "in front" (i.e. depending on the ordering of tags to get a desired parameter is
 * tricky stuff). NOTE: Since Courier only allows tags of max length of 30 chars, we need to ensure we only take a part of
 * a longer string. For orgIds we take the nanoId, which should be unique
 *
 * @param orgId - only the name - without domain, etc
 */
export const encodeOrganizationIdForCourierTags = (orgId: string): string => {
  if (countHyphens(orgId) > 1) {
    return nanoPrefix + extractNanoId(orgId);
  } else {
    return orgPrefix + orgId;
  }
};

// Exported for tests
export const countHyphens = (str: string): number => str.split('-').length - 1;

/**
 * Returns the last part of the orgId splitting at hyphens. nanoId is assumed to be the last part.
 *
 * @param orgId - should include at least one '-' (hyphen)
 */
export const extractNanoId = (orgId: string): string => {
  const parts = orgId.split('-');

  return parts[parts.length - 1];
};

export const decodeOrganizationIdFromCourierTags = (encodedOrgId: string): string =>
  encodedOrgId.includes(nanoPrefix) ? encodedOrgId.replace(nanoPrefix, '') : encodedOrgId.replace(orgPrefix, '');

export const findOrganizationIdTag: (message: IInboxMessagePreviewWithTags) => string | undefined = (
  message: IInboxMessagePreviewWithTags,
) => message.tags?.find((tag) => tag.startsWith(orgPrefix) || tag.startsWith(nanoPrefix));
